import {useState, useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
//components
import {Typography, Paper, Grid, StylesProvider} from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import handleError from '../../utils/handleError';
import MessageRepository from 'client-sdk/src/Repository/message-repository';
import QueryString from 'query-string';
//style
import classes from './index.module.css';
import theme from '../../theme';
import jMoment from 'moment-jalaali';
import RonadIcons from '../../components/iconComponent';

type Tab = "PRIVATE" | "GENERAL" | "SYSTEM"

const Messages = () => {
  const history = useHistory();
  const {search} = useLocation();
  const parameters = QueryString.parse(history.location.search);
  //states
  const [filtersValues, setFiltersValues] = useState({
    privatePage: 0,
    generalPage: 0,
    systemPage: 0,
    sort: 'id,desc',
  });
  const [tab, setTab] = useState<Tab>("PRIVATE");
  const [privateMessages, setPrivateMessages] = useState([]);
  const [privateMessageCount, setPrivateMessagesCount] = useState(0);
  const [generalMessages, setGeneralMessages] = useState([]);
  const [generalMessageCount, setGeneralMessagesCount] = useState(0);
  const [systemMessages, setSystemMessages] = useState([])
  const [systemMessagesCount, setSystemMessagesCount] = useState(0)
  const [showMessage, setShowMessage] = useState({});
  const [notSeens, setNotSeens] = useState({
    notSeenGeneralMessage:0,
    notSeenPrivateMessage:0,
    notSeenSystemMessage:0
  })

  //request
  const getPrivateMessages = async (page:number = 0) => {
    try {
      const response = await MessageRepository.getAllPartnerPrivateMessages({
        payload: {
          ...filtersValues,
          page,
          size: 5,
        },
      });
      setPrivateMessages(response.data);
      setPrivateMessagesCount(parseInt(response.headers['x-total-count']));
    } catch (error) {
      handleError(error);
    }
  };
  const getGeneralMessages = async (page:number = 0) => {
    try {
      const response = await MessageRepository.getAllPartnerGeneralMessages({
        payload: {
          ...filtersValues,
          page,
          size: 5,
        },
      });
      setGeneralMessages(response.data);
      setGeneralMessagesCount(parseInt(response.headers['x-total-count']));
    } catch (error) {
      handleError(error);
    }
  };
  const getSystemMessages = async (page:number = 0) => {
    try {
      const response = await MessageRepository.getAllSystemMessages({
        payload: {
          ...filtersValues,
          page,
          size: 5,
        },
      });
      setSystemMessages(response.data);
      setSystemMessagesCount(parseInt(response.headers['x-total-count']));
    } catch (error) {
      handleError(error);
    }
  };
  const getAllNotSeenCount = async () => {
    try {
      const response = await MessageRepository.getAllNotSeenMessages({
        payload: {},
      });
      setNotSeens(response.data);
    } catch (error) {
      handleError(error);
    }
  }

  const countsMap = {
    "PRIVATE": privateMessageCount,
    "GENERAL": generalMessageCount,
    "SYSTEM": systemMessagesCount
  }

  const getMessageMap = {
    "PRIVATE": getPrivateMessages,
    "GENERAL": getGeneralMessages,
    "SYSTEM": getSystemMessages
  }

  const pageMap = {
    "PRIVATE": filtersValues.privatePage,
    "GENERAL": filtersValues.generalPage,
    "SYSTEM": filtersValues.systemPage
  }

  const makeSeen = async (message: any) => {
    try {
      const callback = await MessageRepository.updateMessageStatus({
        payload: {
          body: {
            messageId: message.id,
            messageType: message.messageType,
          }
        },
      });
      getMessageMap[tab]()
      getAllNotSeenCount()
    } catch (error) {
      handleError(error);
    }
  };

  const makeSystemMessageSeen = async (message: any) => {
    try {
      await MessageRepository.makeSystemMessageSeen({
        payload: {
          id: message.id,
        },
      });
      getMessageMap[tab]()
      getAllNotSeenCount()
    } catch (error) {
      console.log(error)
      handleError(error);
    }
  };

  const removeMessage = async (id: number) => {
    try {
      const {pagination, callback} = await MessageRepository.deleteMessage({
        payload: {
          id,
          pagination: '',
          callback: getMessageMap[tab](),
        },
      });
      callback();
    } catch (error) {
      handleError(error);
    }
  };

  //effects
  useEffect(() => {
    getPrivateMessages();
    getAllNotSeenCount()
  }, []);

  useEffect(() => {
    if (parameters.id) {
      handleTopBarClick()
    }
  }, [search]);

  const handleTopBarClick = async () => {
    try {
      if(parameters.messageType == 'GENERAL') {
        const response = await MessageRepository.getAllPartnerGeneralMessages({
          payload: {
            ...filtersValues,
            page: 0,
            size: 5,
          },
        });
        setGeneralMessages(response.data);
        setGeneralMessagesCount(parseInt(response.headers['x-total-count']));
        const message = response.data.find(generalMessage => {
          return generalMessage.id == parameters.id;
        });
        clickMessageHandler(message);
        setTab("GENERAL");
      }else if(parameters.messageType == 'GENERAL_PRIVATE') {
        const response = await MessageRepository.getAllSystemMessages({
          payload: {
            ...filtersValues,
            page: 0,
            size: 5,
          },
        });
        setGeneralMessages(response.data);
        setGeneralMessagesCount(parseInt(response.headers['x-total-count']));
        const message = response.data.find(privateMessage => {
          return privateMessage.id == parameters.id;
        });
        clickMessageHandler(message);
        setTab("PRIVATE");
      }
    } catch (error) {
      handleError(error)
    }
  }

  //handlers
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    getMessageMap[tab](page - 1)
    setFiltersValues({
      ...filtersValues, 
      privatePage: tab === "PRIVATE" ? page - 1 : filtersValues.privatePage,
      generalPage: tab === "GENERAL" ? page - 1 : filtersValues.generalPage,
      systemPage: tab === "SYSTEM" ? page - 1 : filtersValues.systemPage
    });
  };
  const clickMessageHandler = (message: any) => {
    if (!message.seen) {
      if(message.messageType === "TICKET") {
        makeSystemMessageSeen(message)
      }else {
        makeSeen(message);
      }
    }
    setShowMessage({message: message.message, id: message.id});
    history.replace('/messages');
  };
  const removeMessageHandler = (e, id) => {
    e.stopPropagation();
    removeMessage(id);
  };

  //tab handlers
  const privateTabHandler = () => {    
    setTab("PRIVATE");
    setShowMessage({});
  }
  const generalTabHandler = () => {
    if(generalMessages.length === 0) {
      getGeneralMessages()
    }
    setTab("GENERAL");
    setShowMessage({});
  }
  const systemTabHandler = () => {
    if(generalMessages.length === 0) {
      getSystemMessages()
    }
    setTab("SYSTEM");
    setShowMessage({});
  }

  //JSX
  return (
    <StylesProvider injectFirst>
      <div>
        <Typography variant="h6" component="h1">
          {'پیام ها'}
        </Typography>
        <Paper>
          <ul className={classes.tabContainer}>
            <li
              onClick={privateTabHandler}
              className={classes.tabItems + ' ' + (tab === "PRIVATE" && classes.active)}
            >
              {notSeens.notSeenPrivateMessage > 0 && <span className={classes.badge}>{notSeens.notSeenPrivateMessage}</span>}
              {'پیام‌های خصوصی'}
            </li>
            <li
              onClick={generalTabHandler}
              className={classes.tabItems + ' ' + (tab === "GENERAL" && classes.active)}
            >
              {notSeens.notSeenGeneralMessage > 0 && <span className={classes.badge}>{notSeens.notSeenGeneralMessage}</span>}
              {'پیام‌های عمومی'}
            </li>
            <li
              onClick={systemTabHandler}
              className={classes.tabItems + ' ' + (tab === "SYSTEM" && classes.active)}
            >
              {notSeens.notSeenSystemMessage > 0 && <span className={classes.badge}>{notSeens.notSeenSystemMessage}</span>}
              {'پیام‌های سیستمی'}
            </li>
          </ul>
          <Grid
            xs={12}
            container
            style={{padding: '24px', paddingBottom: '0px'}}
          >
            <Grid style={{position: 'relative'}} xs={6} item container>
              <img
                src="/paperBg.svg"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <Grid
                container
                item
                xs={12}
                wrap="nowrap"
                direction="column"
                style={{
                  position: 'absolute',
                  top: '0',
                  right: '0',
                  // left: "50%",
                  // transform: "translate(-50%, 0%)",
                  width: '100%',
                  height: '100%',
                  overflow: 'auto',
                }}
              >
                {tab === "PRIVATE" && privateMessages.map((privateMessage, index) => {
                      return (
                        <Grid
                          style={{flexBasis: '20%', cursor: 'pointer'}}
                          item
                          container
                          xs={12}
                          className={
                            classes.messages +
                            ' ' +
                            (privateMessage.id == showMessage.id &&
                              classes.selected)
                          }
                          onClick={() => {
                            clickMessageHandler(privateMessage);
                          }}
                        >
                          <Grid
                            style={{padding: '10px'}}
                            item
                            container
                            xs={10}
                          >
                            <Grid spacing={2} xs={12} item container>
                              {!privateMessage.seen && (
                                <Grid item xs={1}>
                                  <div
                                    style={{
                                      width: '10px',
                                      height: '10px',
                                      borderRadius: '50%',
                                      backgroundColor: '#25368C',
                                    }}
                                  ></div>
                                </Grid>
                              )}
                              <Grid
                                style={{fontSize: '16px', fontWeight: '700'}}
                                item
                                xs={9}
                              >
                                {privateMessage.title}
                              </Grid>
                            </Grid>
                            <Grid
                              style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#3838368F',
                              }}
                              xs={12}
                              item
                            >
                              <span>
                                {`${jMoment(privateMessage.created.split("T")[1], 'HH:mm:ss')
                                  .add(3, "hours")
                                  .add(30,"minutes")
                                  .locale('fa')
                                  .format('HH:mm:ss')
                                }
                            `}
                              </span>
                              &nbsp;- &nbsp;
                              <span>
                                {jMoment(privateMessage.created, 'YYYY/M/D')
                                  .locale('fa')
                                  .format('jYYYY/jMM/jDD')}
                              </span>
                            </Grid>
                          </Grid>
                          <Grid
                            justifyContent="center"
                            alignItems="center"
                            item
                            container
                            xs={2}
                          >
                            <Grid
                              style={{
                                borderLeft: '1px solid gray',
                                textAlign: 'center',
                              }}
                              xs={5}
                              item
                              onClick={e =>
                                removeMessageHandler(e, privateMessage.id)
                              }
                            >
                              <RonadIcons name='trash' size={0.8} />
                            </Grid>

                            <Grid style={{textAlign: 'center'}} xs={5} item>
                              <RonadIcons name='chevronLeft' size={1}/>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                })}
                {tab === "GENERAL" && generalMessages.map((generalMessage, index) => {
                  return (
                    <Grid
                      style={{flexBasis: '20%', cursor: 'pointer'}}
                      item
                      container
                      xs={12}
                      className={
                        classes.messages +
                        ' ' +
                        (generalMessage?.id == showMessage?.id &&
                          classes.selected)
                      }
                      onClick={() => {
                        clickMessageHandler(generalMessage);
                      }}
                    >
                      <Grid
                        style={{padding: '10px'}}
                        item
                        container
                        xs={10}
                      >
                        <Grid spacing={2} xs={12} item container>
                          {!generalMessage?.seen && (
                            <Grid item xs={1}>
                              <div
                                style={{
                                  width: '10px',
                                  height: '10px',
                                  borderRadius: '50%',
                                  backgroundColor: '#25368C',
                                }}
                              ></div>
                            </Grid>
                          )}
                          <Grid
                            style={{fontSize: '16px', fontWeight: '700'}}
                            item
                            xs={9}
                          >
                            {generalMessage?.title}
                          </Grid>
                        </Grid>
                        <Grid
                          style={{
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#3838368F',
                          }}
                          xs={12}
                          item
                        >
                          <span>
                            {`${jMoment(generalMessage.created.split("T")[1], 'HH:mm:ss')
                              .add(3, "hours")
                              .add(30,"minutes")
                              .locale('fa')
                              .format('HH:mm:ss')}
                        `}
                          </span>
                          &nbsp;- &nbsp;
                          <span>
                            {jMoment(generalMessage?.created, 'YYYY/M/D')
                              .locale('fa')
                              .format('jYYYY/jMM/jDD')}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid
                        justifyContent="center"
                        alignItems="center"
                        item
                        container
                        xs={2}
                      >
                        <Grid style={{textAlign: 'center'}} xs={5} item>
                          <RonadIcons name='chevronLeft' size={1}/>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
                {tab === "SYSTEM" && systemMessages.map((systemMessage, index) => {
                  return (
                    <Grid
                      style={{flexBasis: '20%', cursor: 'pointer'}}
                      item
                      container
                      xs={12}
                      className={
                        classes.messages +
                        ' ' +
                        (systemMessage?.id == showMessage?.id &&
                          classes.selected)
                      }
                      onClick={() => {
                        clickMessageHandler(systemMessage);
                      }}
                    >
                      <Grid
                        style={{padding: '10px'}}
                        item
                        container
                        xs={10}
                      >
                        <Grid spacing={2} xs={12} item container>
                          {!systemMessage?.seen && (
                            <Grid item xs={1}>
                              <div
                                style={{
                                  width: '10px',
                                  height: '10px',
                                  borderRadius: '50%',
                                  backgroundColor: '#25368C',
                                }}
                              ></div>
                            </Grid>
                          )}
                          <Grid
                            style={{fontSize: '16px', fontWeight: '700'}}
                            item
                            xs={9}
                          >
                            {systemMessage?.title}
                          </Grid>
                        </Grid>
                        <Grid
                          style={{
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#3838368F',
                          }}
                          xs={12}
                          item
                        >
                          <span>
                            {`${jMoment(systemMessage.created.split("T")[1], 'HH:mm:ss')
                              .add(3, "hours")
                              .add(30,"minutes")
                              .locale('fa')
                              .format('HH:mm:ss')}
                        `}
                          </span>
                          &nbsp;- &nbsp;
                          <span>
                            {jMoment(systemMessage?.created, 'YYYY/M/D')
                              .locale('fa')
                              .format('jYYYY/jMM/jDD')}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid
                        justifyContent="center"
                        alignItems="center"
                        item
                        container
                        xs={2}
                      >
                        <Grid style={{textAlign: 'center'}} xs={5} item>
                          <RonadIcons name='chevronLeft' size={1}/>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid style={{position: 'relative'}} xs={6} item>
              <img
                src="/notifBg.svg"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  backgroundColor: 'rgba(255, 255, 255, 0.77)',
                  top: '60px',
                  left: '50%',
                  transform: 'translate(-50%, 0%)',
                  padding: '24px',
                  width: '90%',
                  borderRadius: '20px',
                }}
                dangerouslySetInnerHTML={{__html: showMessage.message}}
              >
              </div>
            </Grid>
          </Grid>
          <Grid xs={12} sm={6} container item direction="row-reverse">
            <Pagination
              className={classes.pagination}
              count={Math.ceil(
                countsMap[tab] / 5
              )}
              color="primary"
              page={pageMap[tab] + 1}
              onChange={handleChangePage}
              shape="round"
            />
          </Grid>
        </Paper>
      </div>
    </StylesProvider>
  );
};

export default Messages;
